import { useAuth, useEntities } from "@emberly/zenith-client";
import { Collapse, Divider, FormControl, FormGroup, FormLabel, Grid, MenuItem, Select, Skeleton, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import axios from "axios";

const useStyles = makeStyles()(
  (theme) => ({

    settings: {
      width: "100%",
      marginTop: theme.spacing(0.5),
      "& label": {
        marginTop: theme.spacing(1),
      }
    },
    select: {

    },
    table: {
      tableLayout: "fixed",
      width: "100%",
      "& td": {
        padding: theme.spacing(1),
        paddingLeft: 0,
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
      },
    },
  })
);


export default function FleetUnitMappings(props) {
  const { apiKey, serviceType, fleetMappings, setFleetMappings } = props;
  const { classes } = useStyles();
  const { entities: serviceVehicles, loading: loadingServiceVehicles } = useEntities("ServiceVehicle");
  const { t } = useTranslation();
  const { getAccessTokenSilently } = useAuth();
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);

  const hasApiKey = useMemo(() => {
    const regex = /^[a-fA-F0-9]+$/;
    return apiKey?.length >= 16 && apiKey?.length <= 128 && regex.test(apiKey);
  }, [apiKey]);

  const takenUnits = useMemo(() => {
    return new Set(Object.values(fleetMappings).filter(t => !!t));
  }, [fleetMappings]);

  useEffect(() => {
    if (hasApiKey) {
      const fn = async () => {
        try {
          const res = await axios.post("/api/integration/fleet/units/list", {
            apiKey,
            service: serviceType
          }, {
            headers: { Authorization: `Bearer ${await getAccessTokenSilently()}` },
          });

          setUnits(res?.data?.units || []);
          setLoading(false);

        } catch (err) {
          console.log(err);
        }
      }

      fn();
    }
  }, [apiKey, hasApiKey, getAccessTokenSilently, serviceType]);


  return (
    <Grid item xs={12}>
      <Collapse in={!loadingServiceVehicles && hasApiKey}>
        <FormControl className={classes.settings}>
          <FormLabel>{t("integrationDialog:fleetUnitMappings")}</FormLabel>
          <FormGroup>
            <Table className={classes.table} sx={{ opacity: loading ? 0.6 : 1.0 }}>
              <TableBody>
                {serviceVehicles?.map((sv, key) => (
                  <FleetUnitMapping key={key} serviceVehicle={sv} units={units} loading={loading || !hasApiKey} setFleetMappings={setFleetMappings} fleetMappings={fleetMappings} takenUnits={takenUnits} />
                ))}
              </TableBody>
            </Table>
          </FormGroup>
        </FormControl>
      </Collapse>
    </Grid>
  );
}



function FleetUnitMapping(props) {
  const { serviceVehicle, units, loading, fleetMappings, setFleetMappings, takenUnits } = props;
  const { t } = useTranslation();
  const { classes } = useStyles();

  const value = fleetMappings[serviceVehicle?.id] || "";

  const onChange = useCallback((ev) => {
    setFleetMappings(mappings => ({ ...mappings, [serviceVehicle?.id]: ev.target.value || "" }));
  }, [serviceVehicle]);

  return (
    <TableRow>
      <TableCell>
        <Typography variant="body2" color="textSecondary">{serviceVehicle.title}</Typography>
      </TableCell>

      <TableCell>
        {loading ? (
          <Skeleton variant="rounded" height="40px" width="256px" sx={{ float: "right", borderRadius: 2 }} />
        ) : (
          <FormControl fullWidth size="small" variant="filled">
            <Select size="small" className={classes.select} hiddenLabel onChange={onChange} value={value}>
              <MenuItem value="">{t("integrationDialog:noMapping")}</MenuItem>
              <Divider />
              {units.map((unit, key) => <MenuItem value={unit.id} key={key} disabled={value !== unit.id && takenUnits.has(unit.id)}>{unit.label} {unit.number}</MenuItem>)}
            </Select>
          </FormControl>
        )}
      </TableCell>

    </TableRow>
  );
}